// src/layouts/MainLayout.jsx

import React, { useEffect, useState } from 'react';
import { useLocation, Outlet, useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const MainLayout = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isEnglish = pathname.startsWith('/en');
  const [hasScrolled, setHasScrolled] = useState(false);

  const languageSwitchUrl = isEnglish
    ? pathname.replace(/^\/en/, '') || '/'
    : '/en' + pathname;

  // ページ内リンク処理（元の仕様）
  const handleBookingClick = (e) => {
    e.preventDefault();
    const homePath = isEnglish ? '/en' : '/';
    const targetId = 'booking';

    if (pathname === homePath || pathname === homePath + '/') {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(`${homePath}#${targetId}`);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100 && !hasScrolled) {
        setHasScrolled(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasScrolled]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Header isEnglish={isEnglish} />

      <main>
        <Outlet />
      </main>

      {/* PC用ボタン（元のデザイン・文言に戻す） */}
      <div className={`desktop-buttons ${hasScrolled ? 'visible' : ''}`}>
        <a
          href="#booking"
          onClick={handleBookingClick}
          className="fixed-reserve-button"
        >
          {isEnglish ? 'Book Now' : 'ご予約'}
        </a>
        <a href={languageSwitchUrl} className="fixed-language-button">
          {isEnglish ? '日本語' : 'English'}
        </a>
      </div>

      {/* スマホ用ボタン（元のデザイン・文言に戻す） */}
      <div className={`mobile-buttons ${hasScrolled ? 'visible' : ''}`}>
        <a
          href="#booking"
          onClick={handleBookingClick}
          className="reserve-button"
        >
          {isEnglish ? 'Book Now' : 'ご予約'}
        </a>
        <a href={languageSwitchUrl} className="language-button">
          {isEnglish ? 'JP' : 'EN'}
        </a>
      </div>

      <Footer isEnglish={isEnglish} />
    </>
  );
};

export default MainLayout;